import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AppButton from "./AppButton";
import { useDispatch, useSelector } from "react-redux";
import {
  IRootState,
  ILoginFormValues,
  ILoginFormErrors,
} from "../../../interfaces";
import { getValidationErrors } from "../../../utills/helpers";
import { LoginValidation } from "../../validations";
import { requestLogin } from "../../../redux/actions";
import { Grid, Typography } from "@material-ui/core";
import { RouteURLs } from "../../../routes/routes";
import { Link } from "react-router-dom";

const LoginConfirmDialog = () => {
  const [formValues, setFormValues] = useState<ILoginFormValues>({
    email: "",
    password: "",
  });
  const [formErrors, setFormErrors] = useState<ILoginFormErrors>({
    email: "",
    password: "",
  });
  const dispatch = useDispatch();
  const { isLoading, reLoginRequired } = useSelector((state: IRootState) => ({
    ...state.loginReducer,
  }));
  //
  const handleFormvaluesChange = (e: any) => {
    const name = e.target.name as "password" | "email",
      value = e.target.value;
    const newFormValues = Object.assign({}, formValues);
    newFormValues[name] = value;
    setFormValues(newFormValues);
    // unset error message
    const newFormErrors = Object.assign({}, formErrors);
    newFormErrors[name] = "";
    setFormErrors(newFormErrors);
  };

  const handleLogin = (e: any) => {
    e.preventDefault();
    try {
      LoginValidation.validateSync(formValues, {
        abortEarly: false,
      });
      dispatch(requestLogin(formValues));
    } catch (error) {
      setFormErrors(getValidationErrors(error));
    }
  };
  return (
    <Dialog open={reLoginRequired || false} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Authentication Required</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please confirm login credentials to continue.
        </DialogContentText>
        <form
          onSubmit={handleLogin}
        >
          <TextField
            className={"form-input"}
            variant="outlined"
            name="email"
            label="Email address"
            type="email"
            error={!!formErrors.email}
            helperText={formErrors.email}
            value={formValues.email}
            fullWidth
            onChange={handleFormvaluesChange}
          />
          <br />
          <TextField
            className={"form-input"}
            variant="outlined"
            name="password"
            label="Password"
            type="password"
            error={!!formErrors.password}
            helperText={formErrors.password}
            value={formValues.password}
            fullWidth
            onChange={handleFormvaluesChange}
          />
          <br />
          <br />
          <AppButton
            size="large"
            color="primary"
            type="submit"
            fullWidth
            text="Login"
            isLoading={isLoading}
            onClick={handleLogin}
          />

          <br /></form>
        <Grid container className={"form-input"}>
          <Grid item sm={8}>
            <Typography>
              Not a member?&nbsp;
              <Link to={RouteURLs.SIGN_UP}>Register here</Link>.
            </Typography>
          </Grid>
          <Grid item sm={4} className={"text-right"}>
            <Typography>
              <Link to={RouteURLs.LOGIN}>Fotgot password?</Link>
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
export default LoginConfirmDialog;
